export default {
  'it-IT': {
    shopNow: 'Compra ora',
  },
  'fr-FR': { shopNow: 'Découvrir' },
  'es-ES': { shopNow: 'Compra ahora' },
  'en-GB': { shopNow: 'Shop now' },
  'en-US': { shopNow: 'Shop now' },
  'de-DE': { shopNow: 'Jetzt kaufen' },
  'en-AU': { shopNow: 'Shop now' },
  'ko-KR': { shopNow: 'Shop now' },
  'ja-JP': { shopNow: 'Shop now' },
};
